import USSD from "../../assets/USSD.png";
import { useTranslation } from "react-i18next";

function Ussd() {
  const { t } = useTranslation();
  return (
    <section className="mt-20 py-10 relative">
      <div className="bg-[rgb(0,73,69)] text-white p-4 md:p-8 w-full flex flex-col gap-2 md:flex-row md:gap-8 lg:rounded-3xl md:h-80 container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="w-full md:w-3/5 flex gap-8 flex-col">
          <h2 className="font-semibold text-2xl">{t("homePage.ussdTitle")}</h2>
          <p className="lg:leading-8">{t("homePage.paragraph2")}</p>
        </div>
        <div className="relative md:absolute md:w-2/5 md:right-0 md:top-0 md:h-full flex justify-center items-center">
          <span className="">
            <img
              src={USSD}
              alt="ussd"
              className="h-96 md:h-[500px] max-w-full"
            />
          </span>
        </div>
      </div>
    </section>
  );
}

export default Ussd;
